import { CONFIG } from "./config.js";
import { initWallet, connectWallet, disconnectWallet, onWalletChange, walletKey } from "./wallet.js";
import { $, $$, short, toast } from "./ui.js";
import { describeError } from "./errors.js";
import { syncClock } from "./chain.js";
import { mountHome } from "./pages/home.js";
import { mountCreate } from "./pages/create.js";
import { mountToken } from "./pages/token.js";
import { mountHow } from "./pages/how.js";
import { mountSecurity } from "./pages/security.js";
import { explorerAddr } from "./config.js";
import { startAmbient } from "./ambient.js";

const app = $("#app");
let cleanup = null;

// plain paths like /security or /how (no hash) map onto the hash routes
if (!location.hash && /^\/(security|how|create|token\/[1-9A-HJ-NP-Za-km-z]{32,44})\/?$/.test(location.pathname)) {
  history.replaceState(null, "", `/#${location.pathname.replace(/\/$/, "")}`);
}

function route() {
  const hash = location.hash.replace(/^#/, "") || "/";
  const parts = hash.split("/").filter(Boolean);
  if (cleanup) {
    try {
      cleanup();
    } catch (e) {
      console.error(e);
    }
    cleanup = null;
  }
  app.innerHTML = "";
  let page = "home";
  if (parts[0] === "create") {
    page = "create";
    cleanup = mountCreate(app);
    document.title = "Launch a token - THE WATER WELL";
  } else if (parts[0] === "token" && parts[1]) {
    page = "token";
    cleanup = mountToken(app, parts[1]);
  } else if (parts[0] === "how") {
    page = "how";
    cleanup = mountHow(app);
    document.title = "How it works - THE WATER WELL";
  } else if (parts[0] === "security") {
    page = "security";
    cleanup = mountSecurity(app);
    document.title = "Security - THE WATER WELL";
  } else {
    cleanup = mountHome(app);
    document.title = "THE WATER WELL - Every trade fills the well";
  }
  app.dataset.page = page;
  app.classList.remove("page-in");
  void app.offsetWidth; // restart the enter animation
  app.classList.add("page-in");
  for (const a of $$(".nav a")) a.classList.toggle("active", a.dataset.nav === page);
  window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  app.focus({ preventScroll: true });
}

function renderWalletButton(pk) {
  const btn = $("#wallet-btn");
  if (pk) {
    btn.textContent = short(pk);
    btn.classList.add("connected");
    btn.title = "Disconnect";
  } else {
    btn.textContent = "Connect Phantom";
    btn.classList.remove("connected");
    btn.title = "";
  }
}

$("#wallet-btn").addEventListener("click", async () => {
  try {
    if (walletKey()) await disconnectWallet();
    else await connectWallet();
  } catch (e) {
    toast({ kind: "error", title: "Wallet", body: describeError(e) });
  }
});

$("#cluster-pill").textContent = CONFIG.cluster === "devnet" ? "Devnet" : "Mainnet";
$("#cluster-pill").classList.toggle("devnet", CONFIG.cluster === "devnet");

// footer program link
const pid = CONFIG.programId;
const progLink = $("#program-link");
if (progLink) {
  progLink.href = explorerAddr(pid);
  progLink.textContent = `Program: ${pid.slice(0, 6)}…${pid.slice(-7)}`;
  progLink.title = `${pid} on Solana Explorer`;
}

// button press ripple (pure decoration)
document.addEventListener("pointerdown", (e) => {
  const b = e.target.closest?.(".btn, .chip, .tab, .seg-btn");
  if (!b || b.disabled) return;
  const r = b.getBoundingClientRect();
  b.style.setProperty("--rx", `${e.clientX - r.left}px`);
  b.style.setProperty("--ry", `${e.clientY - r.top}px`);
  b.classList.remove("pressed");
  void b.offsetWidth;
  b.classList.add("pressed");
  setTimeout(() => b.classList.remove("pressed"), 600);
});

startAmbient();
onWalletChange(renderWalletButton);
initWallet();
syncClock();
setInterval(syncClock, 60_000);
window.addEventListener("hashchange", route);
route();
